/** biome-ignore-all lint/suspicious/noDocumentCookie: <토큰 저장을 위해 사용.> */
export const setClientCookie = (key: string, value: string, days?: number) => {
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${key}=${value};expires=${date.toUTCString()};path=/`;
  } else {
    document.cookie = `${key}=${value};path=/`;
  }
};

export const getClientCookie = (key: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return null;
};

export const deleteClientCookie = (key: string) => {
  document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
};
